import { Screen } from 'constants/tracking/screens'

type SustainabilityImpactViewEventArgs = {
  iconName: string
  position: number
  value: string
}

type SustainabilityImpactViewEventExtra = {
  screen: string
  icon_name: string
  position: number
  value: string
}

export const sustainabilityImpactViewEvent = (args: SustainabilityImpactViewEventArgs) => {
  const { iconName, position, value } = args

  const extra: SustainabilityImpactViewEventExtra = {
    icon_name: iconName,
    position,
    value,
    screen: Screen.SellerInsights,
  }

  return {
    event: 'event_user_view_sustainability_card',
    extra,
  }
}
